import styled from "styled-components";

/**
 * Image that covers its nearest positioned ancestor.
 * The parent must establish a containing block (e.g. `position: relative`).
 */
export const FillImage = styled.img<{ $fit: "cover" | "contain" }>(
  ({ $fit }) => ({
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: $fit,
  }),
);
